import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const TicketsList: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/TicketsListView.vue')
const TicketsKanbanView: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/TicketsKanbanView.vue')
const TicketsItem: DynamicImport = () => import(/* webpackChunkName: "tickets" */ '../views/TicketItemView/TicketItemView.vue')
const MyTicketsView: DynamicImport = () => import('../views/MyTicketsView.vue')
const MyTicketItemView: DynamicImport = () => import('../views/MyTicketItemView/MyTicketItemView.vue')
import TicketForm from '../components/TicketForm/TicketForm.vue'

const routes: (i18n: VueI18n) => RouteConfig[] = i18n => ([
  {
    path: '/tickets/list',
    name: 'tickets-list',
    component: TicketsList,
    meta: {
      title: i18n.t('tickets.ticket.listTitle'),
      buttons: [
        {
          component: TicketForm
        }
      ],
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    path: '/tickets/kanban',
    name: 'tickets-kanban',
    component: TicketsKanbanView,
    meta: {
      title: i18n.t('tickets.ticket.listTitle'),
      pageHeader: false,
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    path: '/tickets/:id',
    name: 'tickets-item',
    component: TicketsItem,
    meta: {
      title: i18n.t('tickets.ticket.itemTitle'),
      pageHeader: false,
      appModule: 'tickets',
      userPermission: ['tickets', 1]
    }
  },
  {
    path: '/app-support',
    name: 'app-support',
    component: MyTicketsView,
    meta: {
      pageHeader: false,
      title: i18n.t('tickets.ticket.pageTitle')
    }
  },
  {
    path: '/app-support/:id',
    name: 'app-support-item',
    component: MyTicketItemView,
    meta: {
      pageHeader: false,
      title: i18n.t('tickets.ticket.pageTitle')
    }
  }
])

export default routes
